import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const downloadAdminBomPdf = createAsyncThunk(
    "/admin/download-bom-pdf",
    async (id) => {
        try {
            const myurl = `${V_URL}/believe/download-bom-pdf/${id}`;
            const response = await axios({
                method: "get",
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
                },
            });
            const data = response.data;
            if (data.success === true) {
                return data;
            } else {
                throw new Error(data.message || "Failed to download BOM PDF");
            }
        } catch (error) {
            console.error("Error in downloadAdminBomPdf:", error);
            toast.error(error.response?.data?.message || "Error generating BOM PDF");
            throw error;
        }
    }
);

const downloadAdminBomPdfSlice = createSlice({
    name: "downloadAdminBomPdf",
    initialState: {
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(downloadAdminBomPdf.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(downloadAdminBomPdf.fulfilled, (state) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(downloadAdminBomPdf.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default downloadAdminBomPdfSlice.reducer;
